import { render } from "./VideoCustom.vue?vue&type=template&id=296b62db&scoped=true"
import script from "./VideoCustom.vue?vue&type=script&lang=ts"
export * from "./VideoCustom.vue?vue&type=script&lang=ts"

import "./VideoCustom.vue?vue&type=style&index=0&id=296b62db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-296b62db"

export default script